<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_012a">Foam</a></h3><a id="file_012a">
<p class="noindent">You will need to have a piece of foam or sponge to absorb the needle when it penetrates through the wool. The best surface to use for needle felting is high-density foam that is at least 1½″ (3.8 cm) thick. Place the wool on the pad and keep needling without worrying about poking your leg or breaking your needle. Some craft stores sell upholstery foam, which can be used in a pinch, but it breaks down faster than the high-density foam.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_012a.vue?b4aa1866